import { BASE_URL } from '../services/api';
// src/services/publicApi.js - Public API Service (No Authentication)

const PUBLIC_API_BASE_URL = BASE_URL;

// Public API service for departments
export const publicDepartmentsAPI = {
  // Get all departments
  getAll: async () => {
    try {
      console.log('📤 [PUBLIC] Fetching all departments...');
      const response = await fetch(`${PUBLIC_API_BASE_URL}/departments.php?action=getAll`);
      
      console.log('📥 [PUBLIC] Response status:', response.status);
      
      // Check content type
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('❌ [PUBLIC] Non-JSON response:', text.substring(0, 200));
        throw new Error('Server returned non-JSON response');
      }
      
      const data = await response.json();
      console.log('✅ [PUBLIC] Departments data received:', {
        success: data.success,
        count: data.count,
        message: data.message
      });
      
      return {
        success: data.success || false,
        data: data.data || [],
        message: data.message || '',
        count: data.count || 0
      };
      
    } catch (error) {
      console.error('❌ [PUBLIC] Error fetching departments:', error);
      
      // Return fallback data
      return getFallbackDepartments();
    }
  },
  
  // Get department by ID
  getById: async (id) => {
    try {
      console.log(`📤 [PUBLIC] Fetching department ID ${id}...`);
      const response = await fetch(`${PUBLIC_API_BASE_URL}/departments.php?action=getById&id=${id}`);
      
      console.log('📥 [PUBLIC] Response status:', response.status);
      
      if (response.status === 404) {
        return {
          success: false,
          message: 'Department not found',
          data: null
        };
      }
      
      // Check content type
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('❌ [PUBLIC] Non-JSON response:', text.substring(0, 200));
        throw new Error('Server returned non-JSON response');
      }
      
      const data = await response.json();
      console.log('✅ [PUBLIC] Department data received:', {
        success: data.success,
        name: data.data?.name
      });
      
      return {
        success: data.success || false,
        data: data.data || null,
        message: data.message || ''
      };
      
    } catch (error) {
      console.error(`❌ [PUBLIC] Error fetching department ${id}:`, error);
      
      // Return fallback data
      return getFallbackDepartmentById(id);
    }
  },
  
  // Get department count
  getCount: async () => {
    try {
      const response = await fetch(`${PUBLIC_API_BASE_URL}/departments.php?action=count`);
      const data = await response.json();
      
      return {
        success: data.success || false,
        count: data.count || 0,
        message: data.message || ''
      };
      
    } catch (error) {
      console.error('❌ [PUBLIC] Error fetching department count:', error);
      return {
        success: true,
        count: 6, // Fallback count
        message: 'Using fallback count'
      };
    }
  }
};

// Fallback data functions
function getFallbackDepartments() {
  console.log('⚠️ [PUBLIC] Using fallback departments data');
  return {
    success: true,
    data: [
      {
        id: 1,
        name: 'Computer Science',
        code: 'CS',
        description: 'The Department of Computer Science offers cutting-edge programs in AI, Machine Learning, Cybersecurity, and Software Engineering. We focus on practical skills and industry-ready training.',
        hod_name: 'Dr. John Smith',
        hod_email: 'hod.cs@college.edu',
        hod_contact: '+91 9876543210',
        building: 'Technology Block',
        floor: '3rd Floor',
        created_at: '2024-01-15 10:30:00',
        updated_at: '2024-12-15 14:20:00'
      },
      {
        id: 2,
        name: 'Mathematics',
        code: 'MATH',
        description: 'Department of Mathematics offering comprehensive programs in Pure and Applied Mathematics, Statistics, and Mathematical Modeling with strong research focus.',
        hod_name: 'Dr. Sarah Johnson',
        hod_email: 'hod.math@college.edu',
        hod_contact: '+91 9876543211',
        building: 'Science Block',
        floor: '2nd Floor',
        created_at: '2024-01-15 10:30:00',
        updated_at: '2024-12-15 14:20:00'
      },
      {
        id: 3,
        name: 'Physics',
        code: 'PHY',
        description: 'Department of Physics with advanced laboratories and research facilities in Quantum Physics, Astrophysics, and Material Science.',
        hod_name: 'Dr. Michael Brown',
        hod_email: 'hod.physics@college.edu',
        hod_contact: '+91 9876543212',
        building: 'Science Block',
        floor: '1st Floor',
        created_at: '2024-01-15 10:30:00',
        updated_at: '2024-12-15 14:20:00'
      },
      {
        id: 4,
        name: 'Chemistry',
        code: 'CHEM',
        description: 'Department of Chemistry offering programs in Organic, Inorganic, Physical Chemistry and Biochemistry with modern laboratory facilities.',
        hod_name: 'Dr. Emily Davis',
        hod_email: 'hod.chemistry@college.edu',
        hod_contact: '+91 9876543213',
        building: 'Science Block',
        floor: 'Ground Floor',
        created_at: '2024-01-15 10:30:00',
        updated_at: '2024-12-15 14:20:00'
      },
      {
        id: 5,
        name: 'Biology',
        code: 'BIO',
        description: 'Department of Biology focusing on Microbiology, Biotechnology, Genetics, and Environmental Science with state-of-the-art research labs.',
        hod_name: 'Dr. Robert Wilson',
        hod_email: 'hod.biology@college.edu',
        hod_contact: '+91 9876543214',
        building: 'Life Sciences Block',
        floor: '2nd Floor',
        created_at: '2024-01-15 10:30:00',
        updated_at: '2024-12-15 14:20:00'
      },
      {
        id: 6,
        name: 'English',
        code: 'ENG',
        description: 'Department of English Literature offering comprehensive study of British, American, and Indian literature with focus on critical analysis.',
        hod_name: 'Dr. Lisa Taylor',
        hod_email: 'hod.english@college.edu',
        hod_contact: '+91 9876543215',
        building: 'Humanities Block',
        floor: '1st Floor',
        created_at: '2024-01-15 10:30:00',
        updated_at: '2024-12-15 14:20:00'
      }
    ],
    message: 'Using fallback data - Backend connection failed',
    count: 6
  };
}

function getFallbackDepartmentById(id) {
  const departments = getFallbackDepartments().data;
  const department = departments.find(dept => dept.id === parseInt(id));
  
  return {
    success: !!department,
    data: department || null,
    message: department ? 'Department retrieved successfully (fallback data)' : 'Department not found'
  };
}

// Public API for courses
export const publicCoursesAPI = {
  getAll: async () => {
    try {
      // You can create a similar public endpoint for courses
      const response = await fetch(`${PUBLIC_API_BASE_URL}/courses.php?action=getAll`);
      const data = await response.json();
      
      return {
        success: data.success || false,
        data: data.data || [],
        message: data.message || ''
      };
    } catch (error) {
      console.error('Error fetching courses:', error);
      return {
        success: true,
        data: [],
        message: 'Courses data not available'
      };
    }
  }
};

// Test connection
export const testPublicConnection = async () => {
  try {
    console.log('🔌 [PUBLIC] Testing public API connection...');
    const response = await fetch(`${PUBLIC_API_BASE_URL}/departments.php?action=getAll`);
    
    const success = response.ok;
    const status = response.status;
    const contentType = response.headers.get('content-type');
    
    console.log(`📊 [PUBLIC] Connection test: ${success ? '✅ SUCCESS' : '❌ FAILED'}`);
    console.log(`📊 [PUBLIC] Status: ${status}`);
    console.log(`📊 [PUBLIC] Content-Type: ${contentType}`);
    
    return {
      success,
      status,
      contentType,
      message: success ? 'Public API connected successfully' : 'Public API connection failed'
    };
  } catch (error) {
    console.error('❌ [PUBLIC] Connection test error:', error);
    return {
      success: false,
      message: `Cannot connect to public API: ${error.message}`,
      suggestion: 'Check if backend/public folder exists and PHP is running'
    };
  }
};